'use client';

import { LotteryGoodsModal as CommonLotteryGoodsModal, useGoodsModalAtom } from '@monorepo/common';

export { useGoodsModalAtom };

function LotteryGoodsModal() {
  return <CommonLotteryGoodsModal />;
}

export default LotteryGoodsModal;
